// extracted by mini-css-extract-plugin
export default {"iconeEngrenagem":"NotificacoesUsuario_iconeEngrenagem__DtnBJ"};